import { useCallback, useState } from 'react';

function useSelectAll() {
  const [selectedItemsIds, setSelectedItemsIds] = useState<string[]>([]);
  const [isAllItemsChecked, setIsAllItemsChecked] = useState<boolean>(false);

  const onItemSelectionToggle = useCallback(
    (itemId: string, isMultichoice?: boolean) => {
      if (isAllItemsChecked) {
        setIsAllItemsChecked(false);
        setSelectedItemsIds([itemId]);
      } else {
        if (!isMultichoice) {
          setSelectedItemsIds([]);
          setSelectedItemsIds((prevState) => {
            return [...prevState, itemId];
          });
        } else {
          setSelectedItemsIds((prevState) => {
            const filteredItems = prevState.filter((item) => item !== itemId);
            if (filteredItems.length < prevState.length) {
              return filteredItems;
            } else {
              return [...prevState, itemId];
            }
          });
        }
      }
    },
    [isAllItemsChecked],
  );

  const onSelectAllItems = useCallback((itemsIds: string[], isForAllItems: boolean) => {
    setSelectedItemsIds(itemsIds);
    setIsAllItemsChecked(isForAllItems);
  }, []);

  const onDeselectAllItems = useCallback(() => {
    setSelectedItemsIds([]);
    setIsAllItemsChecked(false);
  }, []);

  return {
    selectedItemsIds,
    isAllItemsChecked,
    onItemSelectionToggle,
    onSelectAllItems,
    onDeselectAllItems,
  };
}

export default useSelectAll;
